export default __webpack_public_path__ + "static/media/abc7bbe0.svg";